import React from "react";
// Components
import { Main } from "../generalStyle";
import Header from "../../components/firstLogin/sections/header";
import StickyLogo from "../../components/stickyLogo";
import FirstLogin from "../../components/firstLogin"

const FirstLoginView = () => (
  <>
    <Header />
    <Main>
      <StickyLogo />
      <FirstLogin />
    </Main>
  </>
);

export default FirstLoginView;
